import { familyPortalLabel, useGuardians } from '@/features/auth/guardians'
import { AppShell } from './shell/AppShell'
import { adminNavigation, familyNavigation, staffNavigation } from './navigation'

export function AdminLayout() {
  return (
    <AppShell
      navigation={adminNavigation}
      subtitle="Administration"
      homeHref="/admin"
      accountHref="/admin/account"
      searchable
    />
  )
}

export function StaffLayout() {
  return (
    <AppShell
      navigation={staffNavigation}
      subtitle="Staff portal"
      homeHref="/staff"
      accountHref="/staff/account"
    />
  )
}

export function FamilyLayout() {
  const label = familyPortalLabel(useGuardians())
  return (
    <AppShell
      navigation={familyNavigation.map((g) => (g.label === 'Family portal' ? { ...g, label } : g))}
      subtitle={label}
      homeHref="/portal"
      accountHref="/portal/account"
    />
  )
}
